import { Outlet, Route } from "react-router-dom";
import { VideoList } from "../Video-List/Video-List";
import { ShowProvider } from "../../../providers";

const videoRoutes = [
  <Route key={"video"} path="video" element={<Outlet />}>
    <Route
      index
      element={
        <ShowProvider>
          <VideoList />
        </ShowProvider>
      }
    />
  </Route>,
];

export const VIDEO_ROUTES = videoRoutes.map((route) => route);
